<template>
  <div>
    <ul class="min-width-medium">
      <li style="line-height: 1.5rem;" v-for="(value, key) in showData" :key="key">
        <span class="bold">{{ key }}:</span> {{ value }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    payload: {
      type: String,
      required: true
    }
  },
  computed: {
    showData () {
      const obj = JSON.parse(this.payload)
      return Object.keys(obj)
        .filter(key => key !== 'random_token')
        .reduce((newObj, currKey) => {
          newObj[currKey] = obj[currKey]
          return newObj
        }, {})
    }
  }
}
</script>
